import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

export type SortColumn = string | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortTable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '[class.neutral]': 'direction === ""',
    '(click)': 'rotate()',
  },
})
export class SortTableHeaderDirective {

  @Input() sortTable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  @HostListener('click') rotate() {
    if (!this.sortTable) return;
    this.direction = this.direction === 'asc' ? 'desc' : 'asc';
    this.sort.emit({ column: this.sortTable, direction: this.direction });
  }

}
